export { Outlink } from "./Outlink";
export { renderOutro } from "./OutroLogic";
export { default as OutroOverlay } from "./OutroOverlay";
export { Question } from "./Question";

export type OutroPropsExtented = {
  onClose: () => void;
  withTopPadding?: boolean;
};
